export const PublishWindowDays = 7;
export const GoLangZeroDate = '0001-01-01T00:00:00Z'; // This is the empty value for a Date in Golang.
export const DefaultReadmeTemplate = `# Extended Experiment Details
---

`;
